import React from "react";

interface FormFooterProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const FormFooter = React.forwardRef<HTMLDivElement, FormFooterProps>(({ children, className, ...props }, ref) => {
    return (
        <div className={`userful-form-footer ${className || ""}`} ref={ref} {...props}>
            {children}
        </div>
    );
});

FormFooter.displayName = "FormFooter";

export default FormFooter;
